// extracted by mini-css-extract-plugin
export default {"about":"About_about__9wteB","aboutdiv":"About_aboutdiv__PkDVz"};